/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import React from 'react';
import { Typography, Stack } from '@mui/material';
import MaterialSymbol from '../../../components/MaterialSymbol';
import { colors } from '@farmlands/mui-theme';
import { Banner } from '../../../components/Banner';

const OverdrawnBanner: React.FC = () => {
  return (
    <Banner
      color='secondary100'
      sx={{ padding: 1.5 }}
      symbol={<MaterialSymbol sx={{ color: colors.shade100 }}>info</MaterialSymbol>}
      title={
        <Stack direction='row' flexWrap='wrap' alignItems='center' gap={0.5}>
          <Typography variant='h6' color={colors.shade100}>
            Your orders so far exceed your agreement schedule
          </Typography>
        </Stack>
      }
      body={
        <Typography variant='body2' color={colors.shade100}>
          We will contact you if we are unable to fulfil within the terms of the agreement. Please
          contact Farmlands if you would like to secure more for future use.
        </Typography>
      }
    />
  );
};

export default OverdrawnBanner;
